import React from 'react';
import PhenoScanSubTab, { StatCard } from './PhenoScanSubTab';

export default function Disease() {
  return (
    <PhenoScanSubTab
      testIdPrefix="disease"
      analyzeEndpoint="/phenoscan/disease/analyze"
      sampleEndpoint="/phenoscan/disease/sample"
      sampleMetaEndpoint="/phenoscan/disease/sample-meta"
      exportKey="disease"
      title="Disease & Lesion"
      gtFormField="ground_truth_lesion_pct"
      extraParams={{ advanced_mode: false }}
      calibrationRequired={false}
      heatmapKind="disease_lesion"
      heatmapColormap="plasma"
      renderResult={renderResult}
      traitExtractor={(r) => r ? ({
        source: 'phenoscan_disease',
        traits: {
          pct_lesion_area: r.pct_lesion_area,
          pct_chlorotic: r.pct_chlorotic,
          pct_necrotic: r.pct_necrotic,
          lesion_count: r.lesion_count,
          horsfall_barratt_grade: r.horsfall_barratt_grade,
          classification: r.classification,
        },
      }) : null}
    />
  );
}

function renderResult(r) {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
      <StatCard title="Severity" rows={[
        ['Total lesion area (%)', r.pct_lesion_area],
        ['Chlorotic (%)', r.pct_chlorotic],
        ['Necrotic (%)', r.pct_necrotic],
        ['Horsfall-Barratt grade (0-11)', r.horsfall_barratt_grade],
        ['Classification', r.classification],
      ]} />
      <StatCard title="Lesion metrics" rows={[
        ['Lesion count', r.lesion_count],
        ['Leaf area (px)', r.leaf_area_px],
        ['Leaf area (cm²)', r.leaf_area_cm2],
        ['Lesion area (cm²)', r.lesion_area_cm2],
      ]} />
      {r.spatial_distribution && (
        <StatCard title="Spatial distribution" rows={Object.entries(r.spatial_distribution)} />
      )}
      <StatCard title="Method" rows={Object.entries(r.method || {})} />
    </div>
  );
}
